// extracted by mini-css-extract-plugin
export default {"page-wrapper":"styles_page-wrapper__Yara7","ssr-layout":"styles_ssr-layout__C4uLb","layoutContainer":"styles_layoutContainer__TwD-u"};